export const APP_BRAND_NAME = "MartestGo";
